module.exports = __webpack_public_path__ + "static/media/propos-values3.b0380937.png";